import { Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => (
  <footer className="border-t border-border/50 bg-secondary/30 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <Logo size={36} className="rounded-lg" />
          <span className="font-heading font-black text-lg">Kulintara</span>
        </div>
        <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
          Platform discovery kuliner #1 Indonesia. Temukan restoran terbaik di kota kamu, baca review jujur dari influencer terpercaya,
          dan cek jam buka real-time langsung dari owner.
        </p>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-3">Jelajahi</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/restaurants" className="hover:text-primary">Restoran</Link></li>
          <li><Link to="/influencers" className="hover:text-primary">Influencer</Link></li>
          <li><Link to="/map" className="hover:text-primary">Peta Kuliner</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-3">Untuk Bisnis</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/dashboard" className="hover:text-primary">Daftarkan Restoran</Link></li>
          <li><Link to="/dashboard" className="hover:text-primary">Jadi Influencer</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border/50 px-6 py-6 max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-xs text-muted-foreground">
      <span>© 2026 Kulintara. Made with ❤️ for Indonesian food lovers.</span>
      <div className="flex gap-4 mt-3 sm:mt-0">
        <a href="#" className="hover:text-primary"><Instagram className="w-4 h-4" /></a>
        <a href="#" className="hover:text-primary"><Mail className="w-4 h-4" /></a>
      </div>
    </div>
  </footer>
);

export default Footer;
